export const isValidPassword = (password: string): boolean => {
  const pattern = new RegExp(/^[a-zA-Z0-9!@#$&()\\-`.+,/" \\^*_={}<>?:;]*$/);
  return pattern.test(password);
};